import { needResponseStatuses, pendingUpdatesStatuses } from '../constants/aiStatuses';
import type {
  IActionItemsStatusesCount,
  IActionItemsStatusesVisible,
  TActionItemsStatusesKey,
} from '../model/actionItemsStatuses';

export const getAiByStatusSeriesData = (
  needResponse: Record<TActionItemsStatusesKey, IActionItemsStatusesCount>,
  pendingUpdates: Record<TActionItemsStatusesKey, IActionItemsStatusesCount>,
  aiStatusesVisible: IActionItemsStatusesVisible,
) => {
  return !needResponse || !pendingUpdates
    ? []
    : [
        ...(aiStatusesVisible['Need response'] ? needResponseStatuses : []),
        ...(aiStatusesVisible['Pending Update'] ? pendingUpdatesStatuses : []),
      ].map(({ name, color, key }): Highcharts.PointOptionsObject => {
        const state = needResponse[key] || pendingUpdates[key];
        return {
          name,
          y: state.count,
          color,
          sliced: true,
          custom: {
            key,
          },
        };
      });
};
